export const PRODUCT_NAME = "Key";
export const MAIL_PRODUCT_NAME = "Key Mail";
export const AI_PRODUCT_NAME = "Key AI";
